<div>
  <app-alert
    *ngIf="hasNotBalance"
    class="flex-col-container mb-8 mt-24"
    type="danger"
    icon="error_outline"
    lineHeight="lh-1"
    [message]="'MODAL_WITHDRAW.VALIDATIONS.BALANCE' | translate"></app-alert>
  <app-alert
    style="margin-bottom: 32px"
    class="flex-col-container mb-8 mt-24"
    type="warning"
    icon="warning_amber"
    lineHeight="lh-1"
    [message]="'MODAL_WITHDRAW.ALERT' | translate"></app-alert>
  <p class="my-10">{{ 'MODAL_WITHDRAW.STATEMENT' | translate}}</p>

  <div class="p-16 flex-row-container items-center b-0-5 rounded">
    <img class="mr-8" src="assets/svg/account_exoneration.svg" alt="rappi logo" />
    <div class="flex-col-container start flex-1 ml-4">
      <span class="fw-500">{{ 'MODAL_BLOCK_ACC.ACCOUNT_NUMBER' | translate}}</span>
      <span>{{account?.external_number}}</span>
    </div>
    <app-read-only
      [descColor]="account?.status === STATUS.ENABLE ? 'success' : 'warning'"
      [applyBorderBottom]="false"
      [value]="account?.status"></app-read-only>
  </div>

  <form [formGroup]="form">
    <mat-form-field class="w-all mt-24">
      <mat-label>{{ 'MODAL_WITHDRAW.SELECT_REASON' | translate }}</mat-label>
      <mat-select formControlName="reason" name="reason">
        <ng-container *ngFor="let item of reasonOptions">
          <mat-option [value]="item">{{ 'MODAL_WITHDRAW.REASONS.' + item | translate }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-all mt-8">
      <mat-label>{{ 'MODAL_WITHDRAW.SELECT_ACCOUNT' | translate }}</mat-label>
      <mat-select formControlName="concentratorAccount" name="concentratorAccount">
        <ng-container *ngFor="let item of concentratorAccounts$ | async">
          <mat-option [value]="item.origin_transaction">{{ item.origin_transaction + ' - ' + item.banking_core }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-all mb-16">
      <mat-label>{{ 'MODAL_WITHDRAW.AMOUNT' | translate }}</mat-label>
      <input matInput formControlName="amount" required autocomplete="off" />
      <mat-hint align="start">MAX: {{ balance | currencyFormat }}</mat-hint>
    </mat-form-field>
  </form>
</div>
